import ChipColors from '@/app/arch/enums/ChipColors';

export default [
  {
    value: 'Statement',
    text: 'Transação',
    ...ChipColors.light,
  },
  {
    value: 'Users',
    text: 'Usuário',
    ...ChipColors.warning,
  },
  {
    value: 'Payment',
    text: 'Pagamento',
    ...ChipColors.wait,
  },
  {
    value: 'CardBilling',
    text: 'Pagamento com cartão',
    ...ChipColors.light,
  },
  {
    value: 'TerminalStore',
    text: 'Terminal loja',
    ...ChipColors.wait,
  },
  {
    value: 'TerminalLog',
    text: 'Terminal',
    ...ChipColors.warning,
  },
  {
    value: 'UsersBalance',
    text: 'Saldo de usuários',
    ...ChipColors.neutral,
  },
  {
    value: 'QrCodeControl',
    text: 'Qrcodes',
    ...ChipColors.success,
  },
];
